import { SweepFieldTypes } from '../types/enums/SweepFieldTypes';
import { SfdcDisplayType } from '../types/fields';

export const naclFieldTypeToDisplayField = (fieldType: SweepFieldTypes): SfdcDisplayType => {
  switch (fieldType) {
    case SweepFieldTypes.Lookup:
    case SweepFieldTypes.MasterDetail:
    case SweepFieldTypes.Hierarchy:
      return SfdcDisplayType.REFERENCE;

    case SweepFieldTypes.Picklist:
      return SfdcDisplayType.PICKLIST;

    case SweepFieldTypes.MultiselectPicklist:
      return SfdcDisplayType.MULTIPICKLIST;

    case SweepFieldTypes.TextArea:
      return SfdcDisplayType.TEXTAREA;

    case SweepFieldTypes.LongTextArea:
    case SweepFieldTypes.Html:
      return SfdcDisplayType.LONGTEXTAREA;

    case SweepFieldTypes.Number:
    case SweepFieldTypes.FormulaNumber:
    case SweepFieldTypes.Summary:
      return SfdcDisplayType.NUMBER;

    case SweepFieldTypes.Currency:
    case SweepFieldTypes.FormulaCurrency:
      return SfdcDisplayType.CURRENCY;

    case SweepFieldTypes.Checkbox:
    case SweepFieldTypes.FormulaCheckbox:
      return SfdcDisplayType.BOOLEAN;

    case SweepFieldTypes.Date:
    case SweepFieldTypes.FormulaDate:
      return SfdcDisplayType.DATE;

    case SweepFieldTypes.DateTime:
    case SweepFieldTypes.FormulaDateTime:
      return SfdcDisplayType.DATETIME;

    case SweepFieldTypes.Id:
      return SfdcDisplayType.ID;

    case SweepFieldTypes.Geolocation:
      return SfdcDisplayType.GEOLOCATION;

    case SweepFieldTypes.Time:
    case SweepFieldTypes.FormulaTime:
      return SfdcDisplayType.TIME;

    case SweepFieldTypes.Combobox:
      return SfdcDisplayType.COMBOBOX;

    case SweepFieldTypes.Percent:
    case SweepFieldTypes.FormulaPercent:
      return SfdcDisplayType.PERCENT;

    case SweepFieldTypes.Address:
      return SfdcDisplayType.ADDRESS;

    case SweepFieldTypes.EncryptedText:
      return SfdcDisplayType.ENCRYPTEDSTRING;

    case SweepFieldTypes.Email:
      return SfdcDisplayType.EMAIL;

    case SweepFieldTypes.Phone:
      return SfdcDisplayType.PHONE;

    case SweepFieldTypes.Url:
      return SfdcDisplayType.URL;

    case SweepFieldTypes.Text:
    case SweepFieldTypes.FormulaText:
    case SweepFieldTypes.Name:
    case SweepFieldTypes.Name2:
      return SfdcDisplayType.STRING;

    case SweepFieldTypes.AutoNumber:
      return SfdcDisplayType.STRING;

    case SweepFieldTypes.Unknown:
    default:
      return SfdcDisplayType.UNKNOWN;
  }
};
